import axios from '../core/axios';
import {
  BatchUpdateRolePayload,
  CreateRolePayload,
  UpdateRolePayload,
} from '../model/rolesAndPerms.model';

import { ApiConstants } from './api-constants';

export class AdminService {
  private static getAuthToken() {
    const tokenData = sessionStorage.getItem('user-token');
    return tokenData ? JSON.parse(tokenData).AccessToken : null;
  }

  static getAdminUsers = async (limit: number, page: number, query?: any) => {
    return await (
      await axios.get(
        ApiConstants.ADMIN_API.ALL_USERS.URL(limit, page) +
          ApiConstants.ADMIN_API.ALL_USERS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getSearchAdminUsers = async (query: string, limit: number) => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.SEARCH_USERS.URL(query, limit))
    ).data;
  };
  static addUser = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.CREATE_USER.URL(), payload)
    ).data;
  };
  static updateUser = async (email: string, payload: any) => {
    return await (
      await axios.put(ApiConstants.ADMIN_API.UPDATE_USER.URL(email), payload)
    ).data;
  };
  static getUser = async (email: string) => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.UPDATE_USER.URL(email))
    ).data;
  };
  static blockUser = async (email: string) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.BLOCK_USER.URL(email))
    ).data;
  };
  static unBlockUser = async (email: string) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.UNBLOCK_USER.URL(email))
    ).data;
  };
  static batchBlockUsers = async (emails: string[]) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.BATCH_BLOCK_USERS.URL(), { emails })
    ).data;
  };
  static batchUnblockUsers = async (emails: string[]) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.BATCH_UNBLOCK_USERS.URL(), { emails })
    ).data;
  };

  static deleteUser = async (email: string) => {
    return await (
      await axios.delete(ApiConstants.ADMIN_API.DELETE_USER.URL(email))
    ).data;
  };
  static batchDeleteUsers = async (emails: string[]) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.BATCH_DELETE_USERS.URL(), { emails })
    ).data;
  };

  static getRoles = async () => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_ROLES.URL())
    ).data;
  };
  static getRoleDetails = async (roleId: string) => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_ROLE_DETAILS.URL(roleId))
    ).data;
  };
  static createRole = async (payload: CreateRolePayload) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.CREATE_ROLE.URL(), payload)
    ).data;
  };
  static batchUpdateRole = async (payload: BatchUpdateRolePayload) => {
    return await (
      await axios.put(ApiConstants.ADMIN_API.BATCH_CHANGE_ROLES.URL(), payload)
    ).data;
  };
  static updateRole = async (roleId: string, payload: UpdateRolePayload) => {
    return await (
      await axios.put(ApiConstants.ADMIN_API.UPDATE_ROLE.URL(roleId), payload)
    ).data;
  };
  static deleteRole = async (roleId: string) => {
    return await (
      await axios.delete(ApiConstants.ADMIN_API.DELETE_ROLE.URL(roleId))
    ).data;
  };
  static getRolePermissions = async (roleId: string) => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_ROLE_PERMISSIONS.URL(roleId))
    ).data;
  };
  static getAllPermissions = async () => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_ALL_PERMISSIONS.URL())
    ).data;
  };
  static updateRolePermissions = async (roleId: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.UPDATE_ROLE_PERMISSIONS.URL(roleId), {
        permissionIds: payload,
      })
    ).data;
  };
  static getAllFilterRoles = async () => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.ADMIN_ROLE_FILTERS.URL())
    ).data;
  };
  static getAllIntegrations = async () => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_ALL_INTEGRATIONS.URL())
    ).data;
  };
  static getIntegrationDetails = async (integrationId: string) => {
    return await (
      await axios.get(ApiConstants.ADMIN_API.GET_INTEGRATION_DETAILS.URL(integrationId))
    ).data;
  };
  static addIntegration = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ADMIN_API.CREATE_INTEGRATION.URL(), payload)
    ).data;
  };
  static editIntegrationIcon = async (integrationId: string, payload: any) => {
    return await (
      await axios.put(ApiConstants.ADMIN_API.UPDATE_INTEGRATION_ICON.URL(integrationId), payload)
    ).data;
  };
  static updateIntegration = async (integrationId: string, payload: any) => {
    return await (
      await axios.put(ApiConstants.ADMIN_API.UPDATE_INTEGRATION.URL(integrationId), payload)
    ).data;
  };
  static deleteIntegration = async (integrationId: string) => {
    return await (
      await axios.delete(ApiConstants.ADMIN_API.DELETE_INTEGRATION.URL(integrationId))
    ).data;
  };
}
